<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M15 12.5L10 7.5L5 12.5"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconChevronUp',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
